import { Bar } from 'react-chartjs-2';
import type { FunnelStage } from '../../types';

export default function CallFunnelChart({ stage }: { stage: FunnelStage }) {
  return (
    <Bar
      data={{
        labels: ['Total Calls', 'Answered', 'Quality Leads', 'Assessments Booked', 'Interviews Sched.'],
        datasets: [
          {
            data: [
              Number(stage.totalCalls) || 0,
              Number(stage.answered) || 0,
              Number(stage.qualityLeads) || 0,
              Number(stage.assessmentsBooked) || 0,
              Number(stage.interviewsScheduled) || 0,
            ],
            backgroundColor: ['#64748b', '#2a5a8c', '#16a34a', '#2563eb', '#7c3aed'],
            borderRadius: 6,
          },
        ],
      }}
      options={{
        indexAxis: 'y',
        responsive: true,
        maintainAspectRatio: false,
        plugins: { legend: { display: false } },
        scales: {
          x: { beginAtZero: true, ticks: { font: { size: 10 } } },
          y: { ticks: { font: { size: 11 } } },
        },
      }}
    />
  );
}
